import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HtmlToPlaintextPipe } from './html-to-plaintext.pipe';
import { SafevaluePipe } from './safevalue.pipe';



@NgModule({
  declarations: [
    HtmlToPlaintextPipe,
    SafevaluePipe
  ],
  imports: [
    CommonModule
  ],
  exports: [
    HtmlToPlaintextPipe,
    SafevaluePipe
  ]
})
export class PipesModule { }
